import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../assets/css/cards/card-layout.module.css';

const CardLayout = ({ children, title }) => {
    return (
        <div className={styles.card__container}>
            <div className={styles.card__title}>
                <p>{title}</p>
            </div>
            {children}
        </div>
    );
};
CardLayout.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string
};

export default CardLayout;
